export default {"src":"/_next/static/media/map-placeholder.6f06cb7b.svg","height":283,"width":350,"blurWidth":0,"blurHeight":0};